var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('router-link',{staticClass:"router",attrs:{"to":"/categorias"}},[_c('p',[_c('v-icon',{staticClass:"icon",attrs:{"small":"","color":"#6C63FF"}},[_vm._v("mdi-arrow-u-left-bottom")]),_vm._v("Voltar ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }